import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';
import { User } from 'src/app/beans/login/user/user.bean';

@Injectable({
  providedIn: 'root',
})
export class LoginRequest {
  constructor(
    private network: NetworkManager,
    private utils: UtilsManager,
  ) {}

  /**
   *
   * @param username
   * @param psw
   * @param forced
   */
  login(
    username: string,
    psw: string,
    orgId: number,
    orgHubId: number,
    forced: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.LOGIN;

    const headers = new HttpHeaders()
      .append(RequestField.LOGINNAME, username)
      .append(RequestField.PASSWORD, this.utils.hash().md5(psw));

    const form = new URLSearchParams();
    form.set(RequestField.FORCED, forced.toString());

    if (orgId) form.set(RequestField.ORGANIZATION_ID, orgId.toString());
    if (orgHubId) form.set(RequestField.HUB_ID, orgHubId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   */
  logout(token: string) {
    let url = this.network.CodaQApi() + CQWebappApi.LOGOUT;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    return this.network.http().put(url, null, { headers });
  }

  /**
   *
   * @param token
   * @param oldPassword
   * @param newPassword
   */
  changePassword(token: string, oldPassword: string, newPassword: string) {
    let url = this.network.CodaQApi() + CQWebappApi.PASSWORD_CHANGE;

    const headers = new HttpHeaders()
      .append(RequestField.TOKEN, token)
      .append(RequestField.OLD_PASSWORD, this.utils.hash().md5(oldPassword))
      .append(RequestField.NEW_PASSWORD, this.utils.hash().md5(newPassword));

    return this.network.http().put(url, null, { headers });
  }
}
